import React from "react";
import Button from "@material-ui/core/Button";
import Translate from "../../../common/functions/translate";
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { DropdownModel } from '../../../models/dropdownModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { IsolationType, OfferSteps } from '../../../common/enums';
import TextField from "@material-ui/core/TextField";
import PlannerDialog from './plannerDialog';
import { newPlannerProject2Layers } from '../../../common/constants';

const PlannerHouseComponent = (props: any) => {
    const [isOpen, open] = React.useState(false);
    // let buildingTypes = new Array<DropdownModel>(0);
    // buildingTypes = HelperFunctions.enumToDropdownArray(BuildingType, true);
    let isolationTypes = new Array<DropdownModel>(0);
    isolationTypes = HelperFunctions.enumToDropdownArray(IsolationType, true)
    let planner = props.planner;

    let toggleDialog = (isVis, isSaved) => {
        open(isVis);
    }

    if (!planner)
        planner = JSON.parse(JSON.stringify(newPlannerProject2Layers));

    return (<>
        <div style={{ marginBottom: 10 }}>
            {/* <FormControl style={{ width: 300 }}>
                <InputLabel htmlFor="timePeriod-label">{Translate('BuildingType')}</InputLabel>
                <Select
                    name="timePeriodId"
                    value={props.twoDimPlan?.buildingType ? props.twoDimPlan.buildingType : ''}
                    onChange={(e) => props.handleChange('buildingType', e.target.value)}
                    style={{ marginRight: 10 }}
                    inputProps={{
                        id: 'timePeriod-label'
                    }}
                >
                    {
                        buildingTypes.map(m => <MenuItem key={m.value + 'buildingType'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                    }
                </Select>
            </FormControl> */}
            <FormControl style={{ width: 300, marginBottom: 10 }}>
                <InputLabel htmlFor="isolationType-label">{Translate('IsolationType')}</InputLabel>
                <Select
                    name="isolationType"
                    value={props.twoDimPlan?.isolationType ? props.twoDimPlan.isolationType : ''}
                    onChange={(e) => props.handleChange('isolationType', e.target.value)}
                    style={{ marginRight: 10 }}
                    disabled={props.readOnly}
                    inputProps={{
                        id: 'isolationType-label'
                    }}
                >
                    {
                        isolationTypes.map(m => <MenuItem key={m.value + 'isolationType'} value={m.value}> {m.value ? m.label : <em>{m.label}</em>}</MenuItem>)
                    }
                </Select>
            </FormControl>
            <TextField
                name="roomHeight"
                type="number"
                label={Translate("RoomHeight")}
                onChange={(e) => props.handleChange('roomHeight', e.target['value'])}
                value={props.twoDimPlan?.roomHeight || ""}
                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
                disabled={props.readOnly}
            />
            {/* <TextField
                name="position"
                type="text"
                label={Translate("Position")}
                onChange={(e) => props.handleChange('position', e.target['value'])}
                value={props.twoDimPlan?.position || ""}
                style={{ width: 300, marginRight: 10, marginBottom: 10 }}
            /> */}
        </div>
        <Button onClick={(e) => open(true)} color="primary" variant="contained">
            {Translate('TwoDPlan')}
        </Button>
        {/* {props.offer.imgSrc && props.offer.imgSrc !== '' ?
            <img src={props.offer.imgSrc} alt="Two dimentional plan" width={500} height={300} /> : null} */}
        {isOpen ?
            <PlannerDialog
                isOpen={isOpen}
                toggle={toggleDialog}
                activeStepNumber={props.activeStepNumber}
                activeStep={props.activeStep}
                saveClick={props.saveClick}
                catalogType={OfferSteps.TwoDPlan}
                planner={planner}
                offer={props.offer}
                copiedLayer={props.copiedLayer}
            />
            : null}
    </>
    )

}

export default PlannerHouseComponent;
